/* eslint-disable max-len */
import React, {FC} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import BaseSvgIcon from "./Base"

interface Props extends WithDefaultTheme {}

const FilterActive: FC<Props> = ({theme, color = "transparent", active, ...props}) => (
  <BaseSvgIcon {...props} size={16} viewBox="0 0 18 17">
    <g id="filter-active-icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g
        id="Comments-section-default"
        transform="translate(-188.000000, -144.000000)"
        stroke={theme.colors.greys.mediumDark}
        strokeWidth="1.3">
        <g id="Group-2" transform="translate(145.000000, 71.000000)">
          <g id="Group-3" transform="translate(34.000000, 62.000000)">
            <g id="Filter" transform="translate(9.000000, 11.968000)">
              <path
                fill={color}
                d="M17.12,0.49 C16.9992384,0.246580902 16.7517217,0.0918829239 16.48,0.09 L1.48,0.09 C1.20827833,0.0918829239 0.960761563,0.246580902 0.84,0.49 C0.715368756,0.732315485 0.742679754,1.02493332 0.91,1.24 L7.23,9.24 L7.23,14.42 C7.23318723,14.6807717 7.37907967,14.9188067 7.61,15.04 C7.71329655,15.0997421 7.83067424,15.1308127 7.95,15.13 C8.09583189,15.1336988 8.2391759,15.0917445 8.36,15.01 L10.36,13.63 C10.6371343,13.4212983 10.8030406,13.0968593 10.81,12.75 L10.81,9.17 L17.11,1.24 C17.2773202,1.02493332 17.3046312,0.732315485 17.18,0.49 L17.12,0.49 Z"
                id="Path"
              />
              <circle id="Oval" stroke="#FFFFFF" fill="#149BE7" cx="15.0" cy="2.0" r="4.0" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default withTheme(FilterActive)
